export const companiesEn = {
  companies: `Companies`,
  add_company: `Add Company`,
  company_id: `Company ID`,
  company_id_2: `Company ID 2`,
  company_id_3: `Company ID 3`,
  company_id_is_required: `Company ID is required`,
  company_name_is_required: `Company name is required`,
  organization_id: `Organization ID`,
  company_name: `Company Name`,
  update_company: `Update Company`,
  delete_company_title: `Delete Company`,
  delete_company_warning: `Are you sure you want to delete this company?`,
  company_deleted_successfully: `Company deleted successfully`,
  company_not_found: `Company not found`,
  company_details: `Company details`,
  legal_representative: `Legal representative`,
  company_mail_inboxes: `Company mail inboxes`,
  create_mail_inbox: `Create mail inbox`,
  mail_inbox_created_successfully: `Mail inbox created successfully`,
  mail_inbox_deleted_successfully: `Mail inbox deleted successfully`,
  delete_mail_inbox_title: `Delete mail inbox`,
  delete_mail_inbox_warning: `Are you sure you want to delete this mail inbox?`,
  mail_box_email: `Mail box email`,
  actions: `Actions`,
  no_mail_inboxes_found: `No mail inboxes found`,
  filter_mail_inboxes: `Filter mail inboxes`,
  account_class: `Account class`,
  account_receivable: `Account receivable`,
  account_payable: `Account payable`,
  document_type: `Document type`,
  invoice: `Invoice`,
  purchase_order: `Purchase order`,
  delivery_note: `Delivery note`,
  credit_note: `Credit note`,
  debit_note: `Debit note`,
  user: `User`,
  supplier: `Supplier`,
  customer: `Customer`,
  add_filter: `Add Filter`,
  customer_supplier_mutually_exclusive: `Customer and supplier are mutually exclusive`,
  supplier_not_allowed_with_account_receivable: `Supplier not allowed with account receivable`,
  mailbox_supplier_text: `You can specify the supplier who will send you your payable documents`,
  mailbox_customer_text: `You can specify the customer who will receive you your receivable documents`,
  create_mail_inbox_address: `Create a custom mailbox and define its document, supplier, and customer settings.
`,
  manage_email_addresses_used_to_route_incoming_documents: `Manage email addresses used to route incoming documents`,
  mailbox_for_all_documents: `For all documents`,
  mailbox_for_only_scope: `For {{accountClass}} only • {{documentType}}`,
  all_accounts: `all`,
  all_documents: `all documents`,
  no_company_read_permission: `You don't have permission to view companies`,
};
